import { createSlice, PayloadAction } from '@reduxjs/toolkit';
import { IConfig, IToggle } from 'unleash-proxy-client';
import type { UNLEASH } from '../../config/env';

export interface UnleashState {
  status: 'idle' | 'running' | 'stopped';
  environmentUrl: string;
  features: Record<string, IToggle>;
}

export interface VariantPayload<T> {
  enabled: boolean;
  value: T;
}

const initialState: UnleashState = {
  status: 'idle',
  environmentUrl: '',
  features: {},
};

type UnleashConfig = typeof UNLEASH & {
  storageProvider?: IConfig['storageProvider'];
  platform?: 'web' | 'android' | 'ios';
};

const featureFlagSlice = createSlice({
  name: 'featureFlag',
  initialState,
  reducers: {
    startUnleashClient: (state, _action: PayloadAction<UnleashConfig>) => {
      state.status = 'running';
    },
    stopUnleashClient: (state) => {
      state.status = 'stopped';
    },
    restartUnleashClient: (state, _action: PayloadAction<UnleashConfig>) => {
      state.status = 'running';
    },
    setFeatures: (state, action: PayloadAction<Record<string, IToggle>>) => {
      state.features = action.payload;
    },
  },
});

export const featureFlagActions = featureFlagSlice.actions;
export const featureFlagReducer = featureFlagSlice.reducer;